module.exports = __webpack_public_path__ + "static/media/pdf-file-icon.156e218f.svg";